export default "__VITE_ASSET__CL1c6$lF__"